import {get as getStored, set as setStored} from '@explorer/util/store';

// Keys for specific messages
export const MESSAGES_STORE_KEY = 'pl-explorer-messages';

export const MESSAGES_KEYS = {
  BULK_SELECTIONS: 'bulk-selections-hidden',
  OVERZOOM: 'overzoom-message',
  HD_REORDER: 'hosted-data-reorder-message',
  SEPARATE_ACTIONS_BANNER: 'separate-actions-banner',
  COG_DOWNLOAD: 'hide-hosted-data-cog-download-message',
};

// Controls showing a user message (dialogs, snackbars, etc)
// based on user localstorage. Ex) can be used to show a message
// to a user only once.

export const getValue = key => {
  const localStore = getStored(MESSAGES_STORE_KEY);
  if (localStore && localStore[key]) {
    return localStore[key];
  } else {
    return false;
  }
};

export const setValue = (key, value) => {
  const localStore = getStored(MESSAGES_STORE_KEY);
  const messageState = {[key]: value !== 'undefined' ? value : true};
  setStored(
    MESSAGES_STORE_KEY,
    localStore ? {...localStore, ...messageState} : messageState
  );
};
